<template>
    <v-row row wrap>
        <v-col xs12>
            <v-card>
            <span v-bind:key="key" v-for="(item,key) in master.data.blocks" >
                <dynamiclink :block="item" type="layout" :data="blocks_dict[key]" :preview="true"></dynamiclink>
                <br/><br/><br/>
            </span>
            <v-btn text @click="$emit('close')">cancel</v-btn>
            <br/>
            </v-card>
            
        </v-col>
    </v-row>
</template>

<script>
import dynamiclink from '../../components/utils/Block_Dynamic_link.vue'
export default {
    props: ['master','blocks_dict'],
    components: {
        dynamiclink
    },

    data(){
        return {
        }
    },
    methods: {
        
    } 
}
</script>

<style>

</style>
